import * as PropTypes from 'prop-types';

import {PreparedSampleGroup, PreparedUISampleGroup} from 'workflows/samples/PreparedSampleGroupConstants';
import {SAMPLE_GROUP_SHAPE, SampleGroup} from 'workflows/WorkflowConstants';

import {Request, REQUEST_SCHEMA_SHAPE, REQUEST_SHAPE, RequestSchema} from '../RequestConstants';
import {
  REQUEST_TASK_SCHEMA_SHAPE,
  REQUEST_TASK_SHAPE,
  RequestTask,
  RequestTaskSchema,
} from '../tasks/RequestTaskConstants';
import {REQUEST_FULFILLMENT_SHAPE, RequestFulfillment} from './FulfillmentConstants';

export interface HydratedFulfillment {
  fulfillment: RequestFulfillment;
  request: Request;
  sampleGroup: SampleGroup | null;
  requestTask: RequestTask | null;
  requestSchema: RequestSchema;
  requestTaskSchema: RequestTaskSchema | null;
}

export type HydratedFulfillmentWithPreparedSampleGroup = Omit<HydratedFulfillment, 'sampleGroup'> & {
  sampleGroup: PreparedSampleGroup | PreparedUISampleGroup | null;
};

export const HYDRATED_FULFILLMENT_SHAPE = PropTypes.shape({
  fulfillment: REQUEST_FULFILLMENT_SHAPE.isRequired,
  request: REQUEST_SHAPE.isRequired,
  sampleGroup: SAMPLE_GROUP_SHAPE,
  requestTask: REQUEST_TASK_SHAPE,
  requestSchema: REQUEST_SCHEMA_SHAPE.isRequired,
  taskSchema: REQUEST_TASK_SCHEMA_SHAPE,
});
